import Cookies from 'js-cookie';

export const widgetConfig = {
  'total benchmark cost': {
    selectValues: "BENCHMARK_COST AS VALUE",
    title: 'Benchmark',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ['CUSTOMER', 'CARRIER'],
    whereOperators: ['=', '='],
    orderBy: 'BENCHMARK_COST DESC',
    getWhereValue: (params) => [Cookies.get('cp-cn'), params?.carrier],
  },
  'total new cost': {
    selectValues: "NEW_COST AS VALUE",
    title: 'New Cost',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ['CUSTOMER', 'CARRIER'],
    whereOperators: ['=', '='],
    orderBy: 'NEW_COST DESC',
    getWhereValue: (params) => [Cookies.get('cp-cn'), params?.carrier],
  },
  'total savings': {
    selectValues: "SAVINGS AS VALUE",
    title: 'Savings',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ['CUSTOMER', 'CARRIER'],
    whereOperators: ['=', '='],
    orderBy: 'SAVINGS DESC',
    getWhereValue: (params) => [Cookies.get('cp-cn'), params?.carrier],
  },
}